export const REFUSAL_FALLBACK_MESSAGE = "I can't help with that request."

export function isRefusedResponse(
  data: { metadata?: { refused?: boolean } } | null | undefined
): boolean {
  return data?.metadata?.refused === true
}
